import { ITermsAndConditions } from "../../models/termsAndConditions";
export const TermsAndConditionsState: ITermsAndConditions = {
  termsAndConditionsCheckboxState: false,
};
